import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-key */
import { createIcon } from "@chakra-ui/react";
export var ShChevronUpIcon = createIcon({
    displayName: "ChevronUp",
    viewBox: "0 0 18 10",
    path: (_jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.7071 9.70711C17.3166 10.0976 16.6834 10.0976 16.2929 9.70711L9 2.41421L1.70711 9.70711C1.31658 10.0976 0.683418 10.0976 0.292893 9.70711C-0.0976313 9.31658 -0.0976314 8.68342 0.292893 8.29289L8.29289 0.292894C8.48043 0.105357 8.73478 1.45266e-07 9 1.07324e-07C9.26521 6.93824e-08 9.51957 0.105357 9.70711 0.292893L17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711Z", fill: "currentColor" })),
    defaultProps: {
        "aria-label": "ChevronUp icon",
        role: "img",
    },
});
